/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { Table, OverlayTrigger, Row, Col } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import BrowseCategoriesModal from './Modal/BrowseCategoriesModal';
import { renderTooltipDelete, renderTooltipMoreOption } from '../tooltips/PurchaseOrders__ProductsTooltips'
import { cancelGetCategoriesTreeApi, getCategoriesTree } from 'utlis/Apis/Categories_API';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { ERROR_WHILE_FETCHING_PRODUCTS } from 'utlis/AppMessages/AppMessages';
import { getProductVaraitons } from 'utlis/Apis/Products_API';
import { Link } from 'react-router-dom';
import AppFormikInputFieldRadio from 'utlis/helpers/forms/AppFormikInputFieldRadio';

function Product({ item, index, setSelectedProducts, lines }) {
    const [selected, setSelected] = useState(item.selected || lines.filter(e => (e.variant_sku || e.variant_sku) === (item.variant_sku || item.variant_sku)).length > 0)
    return (
        <>
            <div className="d-flex align-items-center justify-content-between product-item">
                <div id="sale-product">
                    <AppFormikInputFieldRadio
                        value={selected}
                        checked={selected}
                        stFormClass={`st-form st-form-with-label-left d-flex flex-wrap align-items-center justify-content-left ${selected ? "text-primary" : ""}`}
                        formikFieldName={"" + item.product_id}
                        labelNameRight={item.product_name}
                        onChange={(e) => {
                            setSelected(!selected)
                            const array = setSelectedProducts
                            item.selected = e.target.checked
                            array[index] = item
                            setSelectedProducts(arr => array)
                        }}
                    />
                    <div className="variant_sku">{item.variant_sku || item.sku}</div>
                    <div className="variant">{item.variant}</div>
                </div>
                <div className={`st-fs-12 ${(item.variant_stock || item.stock) === 0 ? "text-danger" : "text-success"}`} >
                    {(item.variant_stock || item.stock) === 0 ? "out of stock" : "Stock: " + (item.variant_stock || item.stock)}
                </div>
            </div>
        </>
    )

}
function PurchaseOrdersProductsTable(props) {
    const { authState, formik, lines, setLines } = props;
    const [showBrowseCatogoriesModal, setShowBrowseCatogoriesModal] = useState(false);
    const [categoriesList, setCategoriesList] = useState([])
    const [products, setProducts] = useState([])
    const [searchProducts, setSearchProducts] = useState([])
    const [label, setLabel] = useState('')
    const [foundCategory, setFoundcategory] = useState([])
    const [product_name, setProduct_name] = useState('')
    const [foundProduct, setFoundProduct] = useState([])
    const [dropDownList, setDropDownList] = useState(0)

    useEffect(() => {
        let URLParams = `limit=-1`
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCategoriesTree(headers, URLParams).then(res => {
            const resData = res.data
            if (resData && resData.success) {
                setCategoriesList(resData.data)
                setFoundcategory(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategories `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
        return () => {
            cancelGetCategoriesTreeApi()
        }
    }, [authState])

    const getProducts_ = (category, keyword) => {
        if (!keyword) {
            setProducts(arr => [])
            setFoundProduct(arr => [])
        }
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getProductVaraitons(headers, category, keyword).then(res => {
            const resData = res.data
            if (resData && resData.success) {
                if (!keyword) {
                    setProducts(resData.data)
                    setFoundProduct(resData.data)
                } else {
                    setSearchProducts(resData.data)
                }
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_PRODUCTS, {
                    autoClose: 3000,
                    onClose: () => { }
                })
            }
        })
    }

    const filterCategories = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = categoriesList.filter((category) => {
                return category.label.toLowerCase().startsWith(keyword.toLowerCase())
            });
            setFoundcategory(results)
        } else {
            setFoundcategory(categoriesList);
        }
        setLabel(keyword);
    };

    const filterProduct = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = products.filter((product) => {
                return product.product_name.toLowerCase().startsWith(keyword.toLowerCase())
            });
            setFoundProduct(ar => results)
        } else {
            setFoundProduct(ar => products);
        }
        setProduct_name(keyword);
    };

    const closeBrowseCategoriesHandler = () => {
        setProducts(arr => [])
        setFoundProduct(arr => [])
        setShowBrowseCatogoriesModal(false);
    }

    const resetBrowseCategoriesModal = () => {

    }

    const ref = useRef()

    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (dropDownList !== -1 && ref.current && (!ref.current.contains(e.target) || e.target?.id === "reset")) {
                setDropDownList(0)
            }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [])

    return (
        <React.Fragment>
            {showBrowseCatogoriesModal &&
                <BrowseCategoriesModal
                    formik={formik}
                    show={true}
                    lines={lines}
                    closeModal={closeBrowseCategoriesHandler}
                    resetModal={resetBrowseCategoriesModal}
                    categoriesList={categoriesList}
                    getProducts_={getProducts_}
                    selectedProducts={products}
                    setSelectedProducts={setProducts}
                    label={label}
                    filterCategories={filterCategories}
                    foundCategory={foundCategory}
                    setFoundcategory={bool => setFoundcategory(bool)}
                    product_name={product_name}
                    filterProduct={filterProduct}
                    foundProducts={foundProduct}
                    setFoundProduct={bool => setFoundProduct(bool)}
                    setLines={setLines}
                />
            }
            <Table bordered className="mb-0 saleOrder-table">
                <thead>
                    <tr>
                        {props.column_product && (<th><p className="text-capitalize">Product/Service</p></th>)}
                        {props.column__quantity && (<th><p className="text-capitalize">Qty</p></th>)}
                        {props.column__itemPrice && (<th><p className="text-capitalize">Item Price</p></th>)}
                        {props.column__itemTotal && (<th><p className="text-capitalize">Item Total</p></th>)}
                        <th><p></p></th>
                    </tr>
                </thead>
                <tbody>
                    {lines.map((line, index) => {
                        return (
                            <tr key={index} id={"tr" + index}>
                                <td className="column_product d-flex align-items-center" id="column-product"                                >
                                    <div className="w100 d-flex align-items-center"
                                        onClick={(e) => {
                                            setSearchProducts(arr => [])
                                            setDropDownList(index + 1)
                                        }}>
                                        <div className="product_name">{line.product_name || "Select a Product/Service"}
                                            <br />
                                            <span>{line.variant_sku}</span></div>
                                        <div className="icon_">
                                            <FeatherIcon
                                                icon="chevron-down"
                                                size="16"
                                                className="icon me-1" />
                                        </div>
                                    </div>
                                    {((index + 1) === dropDownList) ? <div className="dropDownList"
                                        ref={ref} key={index} id={"ddl" + index}
                                    >
                                        <Row id="dropdownlist-btn" className="m-0" >
                                            <Col lg={6}>
                                                <Link
                                                    type="submit"
                                                    target="_blank"
                                                    className={`st-btn  st-btn-transparent st-btn-sm  w-100 d-flex align-items-center justify-content-center text-primary st-border-none`}
                                                    // disabled={createButtonDisable}
                                                    // onClick={addNewProductHandler}
                                                    to="/catalog/products/create#general_tab"
                                                >
                                                    <FeatherIcon
                                                        icon="plus-circle"
                                                        size="14"
                                                        className="icon me-1" />

                                                    <span>Add New Product</span>
                                                </Link>
                                            </Col>

                                            <Col className="border-left" lg={6}
                                                onClick={(e) => {
                                                    setDropDownList(0)
                                                    setShowBrowseCatogoriesModal(true)
                                                }}>
                                                <button
                                                    type="submit"
                                                    className={`st-btn no-min-width st-btn-transparent w-100 st-btn-sm  no-min-width d-flex align-items-center justify-content-center text-primary st-border-none`}
                                                >
                                                    <FeatherIcon
                                                        icon="plus-circle"
                                                        size="14"
                                                        className="icon me-1"
                                                        id="reset1" />

                                                    <span>Browse Categories</span>
                                                </button>
                                            </Col>
                                        </Row>
                                        <Row className="sale-order-dropdown-item">
                                            <Col lg={12}>
                                                <div className="app-card-content st-border-light align-items-center">
                                                    <Row className="align-items-center">
                                                        <div className="app-card" id="categories">
                                                            <div className="app-card-content-category st-default-rounded-block">
                                                                <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0 mb-4" >
                                                                    <label className="d-none st-label-with-left me-2" value={label}>Search</label>
                                                                    <input type="text" className="form-control"
                                                                        placeholder="Search Product"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value
                                                                            if (value.length > 3) {
                                                                                getProducts_("", value)
                                                                            } else if (value.length === 0) {
                                                                                setSearchProducts(arr => [])
                                                                            }
                                                                        }} />
                                                                    <div className="icon">
                                                                        <FeatherIcon
                                                                            icon="search"
                                                                            size="15"
                                                                            className="icon-main" />
                                                                    </div>
                                                                </div>
                                                                <div className="product-content">
                                                                    {(searchProducts && searchProducts.length > 0) && searchProducts.map((item, index) =>
                                                                        <div key={index}>
                                                                            <Product item={item}
                                                                                {...props}
                                                                                selectedProducts={products}
                                                                                setSelectedProducts={setProducts} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="app-card-content border d-flex align-items-center justify-content-end pad-12-T pad-12-B st-border-no-left "
                                                                    style={{ borderRadius: "0px 0px 8px 8px" }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2 min-height-auto`}
                                                                        onClick={() => {
                                                                            setDropDownList(0)
                                                                        }}
                                                                    >
                                                                        <FeatherIcon
                                                                            icon="rotate-ccw"
                                                                            size="14"
                                                                            className="icon me-1"
                                                                        />
                                                                        <span id="reset">Reset</span>
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2 min-height-auto ${searchProducts.length === 0 ? "disabled" : ""}`}
                                                                        disabled={searchProducts.length === 0}
                                                                        onClick={() => {
                                                                            setDropDownList(0)
                                                                            setLines(arr => [...arr, ...searchProducts.filter(e => e.selected)].filter(e => e.product_name))
                                                                        }}
                                                                    >
                                                                        <FeatherIcon
                                                                            icon="download"
                                                                            size="14"
                                                                            className="icon me-1"
                                                                        />
                                                                        <span>Save</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div> : ""
                                    }
                                </td>

                                <td className="product-quantity">
                                    <div>
                                        <input
                                            className="form-control no-arrows"
                                            id="quantity"
                                            value={line.quantity || (!line.product_id ? 0 : 1)}
                                            type="number"
                                            onChange={(e) => {
                                                const quantity = e.target.value
                                                // if ((line.variant_stock || line.stock) > quantity && quantity > 0) {
                                                if (quantity > 0) {
                                                    line.quantity = quantity
                                                } else {
                                                    line.quantity = (!line.product_id ? 0 : 1)
                                                }
                                                lines[index] = line
                                                setLines(arr => [...lines])
                                            }}
                                        />
                                        {(line.variant_stock || line.stock) < line.quantity ?
                                            <div className="form-error position-absolute">
                                                <p className="st-fs-12">Out of Stock</p>
                                            </div> : ""
                                        }
                                    </div>
                                </td>
                                <td className="column__itemPrice">
                                    <p className="">
                                        {line.variant_price || line.price || 0}
                                    </p>
                                </td>
                                <td className="column__itemTotal">
                                    <p className="">
                                        {(((line.quantity || 0) * (line.variant_price || line.price || 0)) || (line.variant_price || line.price) || 0)}
                                    </p>

                                </td>

                                <td className="column__actions">
                                    <div className="d-flex justify-content-end">
                                        <OverlayTrigger
                                            placement={"left"}
                                            overlay={renderTooltipDelete}>
                                            <button
                                                className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => props.handleDelete(ev, item.manufacturer_id)}
                                                onClick={() => {
                                                    const array = lines.filter(e => (e.variant_sku || e.variant_sku) !== (line.variant_sku || line.variant_sku))
                                                    // if (array.length === 0) { array.push({}) }
                                                    setLines(a => array)
                                                }}
                                            >
                                                <FeatherIcon
                                                    icon="trash-2"
                                                    size="16"
                                                    color="red"
                                                    className="icon" />
                                            </button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement={"left"}
                                            overlay={renderTooltipMoreOption}
                                        >
                                            <button
                                                className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                            // onClick={ev => props.handleDelete(ev, item.manufacturer_id)}
                                            >
                                                <FeatherIcon
                                                    icon="more-vertical"
                                                    size="16"
                                                    className="icon" />
                                            </button>
                                        </OverlayTrigger>
                                    </div>
                                </td>

                            </tr>
                        )
                    })
                    }
                </tbody>
            </Table >
        </React.Fragment >
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(PurchaseOrdersProductsTable)